import { useEffect } from 'react';
import { useStore } from '@ui/hooks/useStore';
import useKeyDown from '@ui/hooks/useKeyDown';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

interface IBatteryVoltage {
    batteryVoltage: number;
}
interface IContactDate {
    date: Date | number | null;
}

const useStatistics = (onClose: ICloseEvent['onClose']) => {
    const { groups, user, devices, lang } = useStore();
    const key = useKeyDown();
    const lowChargeFilter = ({ batteryVoltage }: IBatteryVoltage) => {
        const charge = Math.ceil((batteryVoltage / 3.1) * 100);
        return charge <= 25;
    };
    const longTimeNoContactFilter = ({ date }: IContactDate) => {
        if (!date) return false;
        const timeout = Math.ceil(
            (Date.now() - new Date(date).getTime()) / 1000 / 3600,
        );
        return timeout >= 72;
    };
    const noTelemetryFilter = ({ date }: IContactDate) => {
        return !date;
    };
    const groupsNumber = groups.groupsList.length;
    const devicesNumber = devices.deviceList.length;
    const lowChargeDevicesNumber =
        devices.deviceList.filter(lowChargeFilter).length;
    const longTimeNoContactDevicesNumber = devices.deviceList.filter(
        longTimeNoContactFilter,
    ).length;
    const noTelemetryDevicesNumber =
        devices.deviceList.filter(noTelemetryFilter).length;
    const values = {
        groupsNumber,
        devicesNumber,
        lowChargeDevicesNumber,
        longTimeNoContactDevicesNumber,
        noTelemetryDevicesNumber,
        login: user.userLogin,
    };

    const handleKey = (key: string) => {
        switch (key) {
            case 'Escape':
                onClose();
                break;
        }
    };

    useEffect(() => {
        handleKey(key);
    }, [key]);

    return {
        values,
        lang,
    };
};

export default useStatistics;
